import React, { useEffect, createContext, useContext } from "react";
import * as c from "./referralModal.module.scss";
import { Button } from "@components/shared/button";
import useModal, { Modal } from "@hooks/useModal";
import { useReferralRoute } from "@hooks/referral/useReferralRoute";
import classNames from "classnames";

const ReferralModalContext = createContext();

const ReferralModal = ({ referralType, children }) => {
  const { isOpen, openModal, closeModal } = useModal();
  const { isReferralRoute } = useReferralRoute({ referralType });

  useEffect(() => {
    if (isReferralRoute) {
      openModal();
    }
  }, [isReferralRoute, openModal]);

  return (
    <Modal isOpen={isOpen} onClose={closeModal} className={c.referralModal} closeButtonClassName={c.modalCloseButton}>
      <div className={c.container}>
        <ReferralModalContext.Provider value={{ closeModal }}>{children}</ReferralModalContext.Provider>
      </div>
    </Modal>
  );
};

const Title = ({ className, children }) => <h4 className={classNames("h4", c.title, className)}>{children}</h4>;
const Text = ({ className, children }) => <p className={classNames("p2", c.text, className)}>{children}</p>;
const CloseButton = ({ className, children, href }) => {
  const { closeModal } = useContext(ReferralModalContext);

  if (href) {
    return (
      <Button linkTo={href} size="large" className={className} onClick={closeModal}>
        {children}
      </Button>
    );
  }

  return (
    <Button asHtmlButton size="large" className={className} onClick={closeModal}>
      {children}
    </Button>
  );
};

ReferralModal.Title = Title;
ReferralModal.Text = Text;
ReferralModal.CloseButton = CloseButton;

export { ReferralModal };
